import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import BrandImage from "@/components/brand-image";
import { BackArrow } from "@/components/auth/back-arrow";
import { useIsDarkMode } from "@/hooks/use-theme";

export const Route = createFileRoute("/(auth)")({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();
  const isForgotPassword = location.pathname === "/forgot-password";
  const darkMode = useIsDarkMode();
  const logoName = darkMode ? "logo_white" : "logo";

  return (
    <div className="relative flex h-screen w-screen flex-col md:flex-row dark:bg-gray-800">
      {isForgotPassword && <BackArrow />}
      <BrandImage
        name="login"
        className="absolute inset-0 h-full w-full object-cover md:hidden"
      />

      <div className="hidden py-12 pl-12 md:flex md:w-1/2 4k:p-24">
        <BrandImage
          name="login"
          className="h-full w-full rounded-[40px] object-cover"
        />
      </div>

      <div className="relative flex flex-1 items-center justify-center bg-white/80 md:m-16 md:justify-start md:bg-white lg:m-24 dark:bg-gray-800/80">
        <div className="flex w-full flex-col items-center px-8 md:items-start md:px-0">
          <BrandImage
            name={logoName}
            className="mb-8 h-[64px] w-[271px] md:mb-16 md:h-[80px] md:w-[340px] lg:h-[89px] lg:w-[376px] 4k:h-[250px] 4k:w-[1061px]"
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
